import React, { ChangeEvent, useEffect, useState } from 'react';

interface CounterProps {
    value: number;
    setValue: ( value: number ) => void;
    id: string;
    max?: number;
    min?: number;
    vertical?: boolean;
    textable?: boolean;
    icon?: React.ReactNode;
    disable?: boolean;
}

const Counter = ( { value, max = 100, min = 0, setValue, vertical = false, textable = false, icon, disable = false, id }: CounterProps ) => {
  const [ count, setCount ] = useState( value );

  useEffect( () => {
    setValue( count );
  }, [ count ] );

  useEffect( () => {
    setCount( value );
  }, [ value ] );


  const handleClick = ( event: React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {
    if ( disable ) {return;}
    switch ( ( event.target as unknown as { id: string } ).id ) {
    case 'incr-button' + id: return incrementValue();
    case 'decr-button' + id: return decrementValue();
    default: return;
    }
  };

  const handleValueChange = ( event: ChangeEvent<HTMLInputElement> ) => {
    const val = parseInt( event.target.value );
    if ( val <= max && val >= min )
    { setCount( val ); }

    else if ( ( event.nativeEvent as unknown as { data: unknown } ).data == null && ( count < 10 && count > -10 ) )
    {setCount( 0 );}

    ( event.target as unknown as { value: number } ).value = count;
  };

  const incrementValue = (): void => {
    const newVal = count + 1;
    if ( newVal > max ) {return;}

    setCount( newVal );
  };

  const decrementValue = (): void => {
    const newVal = count - 1;
    if ( newVal < min ) {return;}

    setCount( newVal );
  };

  return (
    <div className='m-px text-xs relative text-center w-fit flex bg-gray-100 border border-px border-gray-200 rounded'>
      { icon != null && icon }
      <div id={ 'counter' + id} className="px-1 m-px py-px text-center rounded-sm ">
        { vertical ? (
          <div className="relative h-full w-16 flex justify-between bg-white/70 rounded divide-x divide-gray-300">
            <button type='button' id={'decr-button' + id} className="w-1/3 hover:bg-white/90 rounded-l" onClick={handleClick}> - </button>

            { ( textable && !disable ) ?
              <input className="w-1/3 input-none text-center" type="number" id={'input-counter' + id} value={count} onChange={handleValueChange}/> :
              <div className="w-1/3 py-1"> {count} </div>
            }

            <button type='button' id={'incr-button' + id} className="w-1/3 hover:bg-white/90 rounded-r" onClick={handleClick}> + </button>
          </div>
        ) : (
          <div className="relative h-full w-14 raw-flex justify-between bg-white/70 rounded divide-y divide-gray-300">
            <button type='button' id={'incr-button' + id} className="w-2/3 hover:bg-gray-200/90 rounded-b" onClick={handleClick}> + </button>

            { ( textable && !disable ) ?
              <input className="w-1/3 input-none text-center" type="number" id={'input-counter' + id} value={count} onChange={handleValueChange}/> :
              <div className="w-2/3 place-self-center"> {count} </div>
            }

            <button type='button' id={'decr-button' + id} className="w-2/3 hover:bg-gray-200/90 rounded-t" onClick={handleClick}> - </button>
          </div>
        ) }
      </div>
    </div>
  );
};

export default Counter;